import axiosDmsInstance from './axiosDmsInstance';
import { handleApiError } from '../../common/util';
import { ISystemConfiguration } from '../../models/dms/systemConfiguration.model';

export const getScheduleStartTime = async () => {
  try {
    const url = `/api/system/configuration/v1/systemConfig/Schedule Start Time`;
    const params = {
      type: 'DateValue',
    };

    const response = await axiosDmsInstance.get<ISystemConfiguration>(`${url}`, {
      params
    });

    return response.data;
  } catch (err: any) {
    return handleApiError('getScheduleStartTime', err);
  }
};

export const getScheduleEndTime = async () => {
  try {
    const url = `/api/system/configuration/v1/systemConfig/Schedule End Time`;
    const params = {
      type: 'DateValue',
    };

    const response = await axiosDmsInstance.get<ISystemConfiguration>(`${url}`, {
      params
    });

    return response.data;
  } catch (err: any) {
    return handleApiError('getScheduleEndTime', err);
  }
};